import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { About } from "@/components/sections/About";
import { Services } from "@/components/sections/Services";
import { AfricaBand } from "@/components/sections/AfricaBand";
import { Contact } from "@/components/sections/Contact";
import { useLang } from "@/context/LanguageContext";

export default function Home() {
  const { loading } = useLang();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-creme">
        <div className="h-8 w-8 rounded-full border-2 border-ligne border-t-rouge animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-creme">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <AfricaBand />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
